import type { FC } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import type { SxProps, Theme } from '@mui/material'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useAuth } from 'react-oidc-context'

export const AuthCallbackPage: FC = () => {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.user && !auth.isLoading) {
      navigate('/dashboard', { replace: true })
    }
  }, [auth.user, auth.isLoading, navigate])

  return (
    <Box sx={containerSx}>
      <Box sx={contentSx}>
        <CircularProgress size={32} />
        <Typography variant="h6" sx={titleSx}>
          Completing Authentication
        </Typography>
        <Typography variant="body2" sx={subtitleSx}>
          Please wait while we process your login...
        </Typography>
      </Box>
    </Box>
  )
}

const containerSx: SxProps<Theme> = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'background.default',
}

const contentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
}

const titleSx: SxProps<Theme> = {
  color: 'text.primary',
}

const subtitleSx: SxProps<Theme> = {
  color: 'text.secondary',
}
